import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {activateWidePopup} from "../../ducks/popup-duck.js";
import Search from "./Search.jsx";

export default () => {

    const dispatch = useDispatch()

    const onKeyDown = async e => {
        if(e.ctrlKey && e.key === '|') {
            await dispatch(activateWidePopup(<Search />))
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', onKeyDown)
        return () => {
            document.removeEventListener('keydown', onKeyDown)
        }
    })

    return (
        <div onKeyDown={onKeyDown} />
    )
}